import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { getData as apiGetData } from 'api/Api'
import {
  FormControl
} from 'react-bootstrap'
import Loader from 'components/Loader'
import PluginForm from '../Form'

export class PluginFormPicker extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    args: PropTypes.array,
    onChange: PropTypes.func,
    onSubmit: PropTypes.func,
    onBusyChange: PropTypes.func,
    children: PropTypes.func
  }

  static defaultProps = {
    type: ''
  }

  constructor (props) {
    super(props)

    this.state = {
      isLoaded: false,
      isSubmitting: false,
      pluginTypes: [],
      selectedPluginTypeIndex: null
    }

    this.submit = this.submit.bind(this)
    this.fetchPluginTypes = this.fetchPluginTypes.bind(this)
    this.renderFormPicker = this.renderFormPicker.bind(this)
    this.handlePluginFormRef = this.handlePluginFormRef.bind(this)
    this.handlePluginTypeChange = this.handlePluginTypeChange.bind(this)
  }

  componentDidMount () {
    this.fetchPluginTypes()
  }

  componentDidUpdate (prevProps) {
    if (this.props.type !== prevProps.type) {
      this.fetchPluginTypes()
    }
  }

  submit () {
    if (this.submitPromise) return this.submitPromise

    this.setState({
      isSubmitting: true
    })

    this.submitPromise = this.pluginFormRef.handleSubmit()

    this.submitPromise.finally(() => {
      this.setState({
        isSubmitting: false
      })

      delete this.submitPromise
    })

    return this.submitPromise
  }

  fetchPluginTypes () {
    const { type } = this.props

    this.fetchPluginTypesPromise = apiGetData('PluginTypes', { type })
    this.fetchPluginTypesPromise.then(({ Types }) => {
      this.setState({
        isLoaded: true,
        pluginTypes: Types.map(Type => ({
          identifier: Type.Identifier,
          name: Type.DisplayName
        })),
        selectedPluginTypeIndex: 0
      })
    })
  }

  handlePluginFormRef (ref) {
    this.pluginFormRef = ref
  }

  handlePluginTypeChange (event) {
    this.setState({
      selectedPluginTypeIndex: +event.target.value
    })
  }

  renderFormPicker () {
    const {
      type,
      args,
      onChange,
      onSubmit,
      onBusyChange
    } = this.props
    const {
      isLoaded,
      pluginTypes,
      selectedPluginTypeIndex
    } = this.state

    const plugin = pluginTypes[selectedPluginTypeIndex]

    return (
      <div>
        {!isLoaded &&
          <Loader center />
        }
        {(isLoaded && pluginTypes.length > 1) &&
          <FormControl
            className='m-b-5'
            componentClass='select'
            value={selectedPluginTypeIndex}
            onChange={this.handlePluginTypeChange}
          >
            {pluginTypes.map((pluginType, index) =>
              <option
                key={pluginType.id}
                value={index}
              >
                {pluginType.name}
              </option>
            )}
          </FormControl>
        }
        {(isLoaded && plugin) &&
          <PluginForm
            {...plugin}
            ref={this.handlePluginFormRef}
            type={type}
            args={args}
            onChange={onChange}
            onSubmit={onSubmit}
            onBusyChange={onBusyChange}
          />
        }
        {(isLoaded && !plugin) &&
          <p>
            <FormattedMessage id='PLUGIN_NOT_FOUND' />{': '}{type}
          </p>
        }
      </div>
    )
  }

  render () {
    const {
      isLoaded,
      isSubmitting,
      pluginTypes,
      selectedPluginTypeIndex
    } = this.state

    const plugin = pluginTypes[selectedPluginTypeIndex]

    if (this.props.children) {
      return this.props.children({
        render: this.renderFormPicker,
        submit: this.submit,
        isLoaded,
        isSubmitting,
        plugin
      })
    } else {
      return this.renderFormPicker()
    }
  }
}

export default PluginFormPicker
